interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
}

export default function SectionHeading({ eyebrow, title, desc, align = 'left' }: SectionHeadingProps) {
  return (
    <div className={align === 'center' ? 'text-center' : 'text-left'}>
      <div
        className={`inline-flex items-center gap-2 rounded-full bg-primary-100/80 px-3 py-1 text-xs font-medium tracking-widest text-primary-700 ${
          align === 'center' ? 'mx-auto' : ''
        }`}
      >
        <span className="h-1.5 w-1.5 rounded-full bg-primary-500" />
        {eyebrow}
      </div>
      <h2 className="mt-4 text-2xl font-bold leading-tight text-foreground-950 md:text-4xl text-balance">
        {title}
      </h2>
      {desc ? (
        <p
          className={`mt-4 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base ${
            align === 'center' ? 'mx-auto' : ''
          }`}
        >
          {desc}
        </p>
      ) : null}
    </div>
  );
}